// field_writeback — writes a value onto the appraisal (status changes run the manual status side effects).
import React, { useState } from 'react';
import { Database, CheckCircle2 } from 'lucide-react';
import { StepCard, StepNav, ErrorLine, writeback, humanise } from './_stepKit';

export default function FieldWriteback({ action, value, onChange, onNext, onBack, canBack, capturedData }) {
  const p = action.params || {};
  const fixed = p.value ?? '';
  const [val, setVal] = useState(value?.value ?? fixed ?? '');
  const [done, setDone] = useState(value?.written_at || null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const save = async () => {
    setBusy(true); setErr('');
    try {
      const res = await writeback(capturedData, p.field, val);
      const out = { field: p.field, value: val, written_at: res?.written_at || new Date().toISOString() };
      setDone(out.written_at); onChange(out);
    } catch (e) { setErr(e?.response?.data?.detail || e.message || 'Write failed'); } finally { setBusy(false); }
  };

  return (
    <div>
      <StepCard icon={Database} title={`Update ${humanise(p.field)}`} testid="wf-field-writeback">
        {p.value_or_prompt && <div className="text-sm text-slate-600">{p.value_or_prompt}</div>}
        {fixed !== '' ? (
          <div className="text-sm text-slate-700">Sets <b>{humanise(p.field)}</b> to <b data-testid="wf-field-writeback-value">{String(fixed)}</b>.</div>
        ) : (
          <input value={val} onChange={(e) => setVal(e.target.value)} data-testid="wf-field-writeback-input"
            className="w-full border border-slate-300 rounded px-3 py-2 text-sm" placeholder="Value" />
        )}
        {done ? (
          <div className="text-sm text-emerald-700 flex items-center gap-1.5" data-testid="wf-field-writeback-done">
            <CheckCircle2 size={15} /> Saved {new Date(done).toLocaleString('en-NZ')}
          </div>
        ) : (
          <button onClick={save} disabled={busy || val === ''} data-testid="wf-field-writeback-save"
            className="px-4 py-2 rounded bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700 disabled:opacity-40 transition-colors">
            {busy ? 'Saving…' : 'Apply now'}
          </button>
        )}
        <ErrorLine err={err} testid="wf-field-writeback-err" />
      </StepCard>
      <StepNav canBack={canBack} onBack={onBack} onNext={onNext} disabled={!done} />
    </div>
  );
}
